/*
 * --------------------------------------------------------------------------
 * CREATE RETURNS RELATED JAVASCRIPT STARTS
 * ----------------------------------------------------------------------------
 */

// Global variables
var keep;
var totalItems;
var keepInEachOrder;
var totalItemsInEachOrder;

jQuery(function($) {

    // Display UPS pop-up on page load in return confirmation page
    if (($('#wcs-pageName').val() == 'returnConfirmation') && ($('#wcs-serviceCode').val() != 'N')) {
        display_center_1($("#wcs-print_UPS_label"));
        $("#wcs-print_UPS_label").css("display", "block");

        const isOnlyEPPInReturnConfirmationPage = $('#isOnlyEPPInReturnConfirmationPage').val() === 'true';

        if (!isOnlyEPPInReturnConfirmationPage) {
            $(".wcs-fadeout-full").css("height", $(document).height());
        }

        $('#ups_form').submit();
    }

    // Submit the relevant form on click of print ups link
    $(".wcs-print-ups").on("click", function(e) {
        e.preventDefault();
        var rmaid = $(this).data("rmaid");
        $("#ups_form_" + rmaid).submit();
    });

    // Form submission when guest user goes back to orders page from create return page
    $("#wcs-back-to-orders").click(function(e) {
        e.preventDefault();
        $("#back-to-orders").submit();
    });

    // Form submission for return history page
    $("#wcs-return-history-link").click(function(e) {
        e.preventDefault();
        $("#wcs-order-return-history").submit();
    });

    // Form submission for create return link
    $("#wcs_create_return").click(function(e) {
        e.preventDefault();
        if (!$("#wcs_create_return").parent().hasClass("wcs-disabled"))
            $("#create-return").submit();
    });

    $('.js-create-return-btn').click(function(e) {
        e.preventDefault();
        var orderID = $(this).attr('data-order-id');
        var createReturnForm = $('#create-return');
        createReturnForm.find('input[name="guestOrderId"]').val(orderID);
        createReturnForm.submit();
    })

    $("#create_return_form").submit(function(e) {
        e.stopPropagation();
    });
    
    $('#return_wcs_contact_us').off('click').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('#wcs_contact_us').trigger('click');
    });

    // Form submission for edit return link
    $("#wcs-edit-return-link").click(function(e) {
        e.preventDefault();
        $("#edit-return").submit();
    });

    // Disable create return link
    $(".wcs-create-return-container.wcs-disabled > a").click(function(e) {
        e.preventDefault();
    });    
    
    //To trigger the ajax call on page load when returning to Create Return page
    if ($('#wcs-rma-id').val() !== '' && $('#wcs-pageName').val() == 'createReturn') {

        $(".wcs-create-return .wcs-myOrder-rows").each(function() {
            var quantity = $(this).find(".wcs-return-price").data("price");
            var unitPrice = $(this).find(".wcs-quantity").val();
            $(this).find(".wcs-return-price").html(calcAndFormatPrice(quantity, unitPrice));
        });
        createReturnCostAjax(collectParams(), "CreateReturnCalcCmd");
        $(".wcs-return-reason-dd").each(function() {
            showHideReturnReasonResponse(this, this.value.split("-", 1).toString(), this.value);
            /*if(this.value != "REP-KP" && this.value.split("-",1).toString() == "RET") {
             $("#return_pdt_price_"+this.name.split("_")[1]).find(".wcs-return-price").show();
             } else if(this.value != "REP-KP" && this.value.split("-",1).toString() == "REP"){
             $("#return_pdt_price_"+this.name.split("_")[1]).find(".wcs-replace-price").show();
             }*/
        });

        $(".wcs-note-org-shipment").show();

    }

    // Listener for change in quantity through key up and down
    $('.wcs-create-return .wcs-dropdown-text').keydown(function(e) {
        // Update the total dd and keep count
        updateKeepCount();

        // Update the price shown based on quantity selected
        var quantity = $(this).parents(".wcs-custom-dropdown-container").find(".wcs-dropdown-text").val();
        var unitPrice = $(this).parents(".wcs-myOrder-rows").find(".wcs-return-price").data("price");
        $(this).parents(".wcs-myOrder-rows").find(".wcs-return-price").html(calcAndFormatPrice(quantity, unitPrice));


        if (keep != totalItems) {
            if (e.which == 40 || e.which == 38) {
                createReturnCostAjax(collectParams(), "CreateReturnCalcCmd");
            }
        }
    });

    // Listener for change in quantity through mouse click
    $('.wcs-create-return .wcs-custom-dropdown').on("click", function(e) {
       updateForm(this)
    });

     // Listener for change in quantity through mouse click
        $('.wcs-create-return .wcs-custom-dropdown li').on("click", function(e) {
           updateForm(this)
        });

    /* RB-7210 fix*/
    $('#wcs_support_topic').change(function(){
        if($(this).val() !== ""){
            $(this).parent().parent().parent().find('.wcs-error-message').removeClass('wcs-show');
            $(this).parent().parent().parent().removeAttr('style');
            $(this).removeClass('ui-state-error');
        }
    });

    updateKeepCount();
    if (keep == totalItems) {
        $("#return_order_confirm").show().attr("disabled", true).addClass("wcs-btn-disable");
    }else{
        $("#return_order_confirm").removeAttr("disabled").removeClass("wcs-btn-disable");
    }

    openCallWindow();
    
    $("#footer_chat, #footer_callback").off("click").on("click",function(e){
    	$.cookie('clicked',true, { path: '/' });
    	highlightFooter();
    });
    if(($("#page").val() === "ClickToCall" || $("#page").val() === "ClickToChat") && $.cookie('clicked') === "true"){
    	highlightFooter();
    }
    
    showCustomerCareHours();
});
window.highlightFooter = function(){
	$("#footerWrapper div.wcs-primary a#wcs_contact_us").css("color","#fff");
	$("#footerWrapper div.wcs-primary a#countryId").parent().addClass("wcs-dim");
};
// Tabbing for create return history page
window.myOrdersTabbing = function() {
    $(".wcs-title-open-orders").on("click", function(e) {
        e.preventDefault();
        var currentTabHanlder = $(this);
        var curentTab = $(this).data("tabid");
        if ($(currentTabHanlder).hasClass("wcs-inactive")) {
            $(".wcs-title-open-orders").addClass("wcs-inactive");
            $(currentTabHanlder).removeClass("wcs-inactive");

            if (curentTab == "wcs-return-history-tab") {
                $("#wcs-order-history-tab").hide();
                $("#" + curentTab).show();
            } else {
                $("#wcs-return-history-tab").hide();
                $("#" + curentTab).show();
            }

        }
    });
};

// Show/Hide product price based on the return reason selected
window.showHideUnitPrice = function(obj, reasonPrefix, reasonCode) {
    $("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-price").hide();

    if (reasonCode == "REP-KP") {
        $("#return_pdt_price_" + obj.name.split("_")[1]).hide();
    } else {
        $("#return_pdt_price_" + obj.name.split("_")[1]).show();
        if (reasonPrefix == "RET"){
            $("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-return-price").show();
            if($("#insuranceCart").val()){
            	$("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-return-discounted-price").show();
            }
			$("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-order-confirm-vat").show();
		}
        else if (reasonPrefix == "REP" && reasonCode != "REP-KP") {
            $("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-replace-price").show();
			$("#return_pdt_price_" + obj.name.split("_")[1]).find(".wcs-order-confirm-vat").hide();
		}
    }
};

// Make an ajax request to calculate the total refund
window.createReturnCostAjax = function(params, url,disableConfirm) {
    $.ajax({
        type: "POST",
        url: url,
        data: params,
        success: function(result) {

            $(".wcs-create-return").find("#ajax_response").empty();
            $("#ajax_response").html(result).promise().done(function() {
                // to make custom radio buttons work
                custom_label();
                setupLabel('');

                // UPS service availability for selected address
                upsServiceAvailability($("#ajax_response .wcs-label-radio").find("input[type='radio']:checked").data("upsservice"));

                // Hide/show next/confirm buttons based on radio selection
                addressRadioHandler();

                if (params.noReturnItems === 0) {
                    $("#ajax_response .wcs-return-shipment-cost").css({"border-top": "none", "margin-top": "0px", "padding-top": "0px"});
                } else {
                    $("#ajax_response .wcs-return-shipment-cost").css({"border-top": "1px solid #eee", "margin-top": "10px", "padding-top": "10px"});
                }
                var return_shipment_cost = $(result).find("#return_shipment_cost").val();
                // if shipmentServiceTypeSelection is enabled
                var shipmentCost = 0;
                if ($(".wcs-shipping-service-radio").length > 0) {
                    shipmentCost = $(".wcs-shipping-service-radio:checked").data("shipment-cost");
                }
                // Check for selected delivery add
                var deliveryAddSelected;
                deliveryAddSelected = ($(".wcs-address-radios input:radio:checked").hasClass("wcs-new-add-radio") === true) ? "newadd" : "origadd";

                if (return_shipment_cost > 0 || shipmentCost > 0 || deliveryAddSelected == "newadd") {
                    showNextButton();
                } else {
                    showConfirmButton();
                }
                if ($('#wcs-rma-id').val() !== '' && $('#wcs-pageName').val() == 'createReturn') {
                    if (parseInt($("#ajax_response").find("#return_shipment_cost").val()) <= 0) {
                        if ($('.wcs-address-radios .wcs-new-add-radio').is(':checked')) {
                            showNextButton();
                        } else {
                            showConfirmButton();
                        }
                    } else {
                        showNextButton();
                    }
                }

                onShippingTypeSelection();
            });
            //RB-10764
            if(disableConfirm === true){
                $("#return_order_confirm").removeAttr("disabled").removeClass("wcs-btn-disable");
            }
        },
        error: function(xhr, ajaxOptions, thrownError) {
            if (window.console)
                console.log(thrownError);
        }
    });
};

// Show the return/refund message based on the reason selected
window.showHideReturnReasonResponse = function(obj, reasonPrefix, reasonCode) {
    $(obj).closest('.wcs-myOrder-status-section').find(".response-to-return-reason > p").hide();

    if (reasonCode != "REP-KP")
        $(obj).closest('.wcs-myOrder-status-section').find(".wcs-reason-" + reasonPrefix.toLowerCase()).show();
};

// Collect the states of each item
window.collectParams = function() {
    var noReturnItems = 0;
    var params = {};

    $(".wcs-myOrder-rows").each(function() {
        var itemName = $(this).find(".wcs-orderItemId").attr("name");
        var itemNameValue = $(this).find(".wcs-orderItemId").attr("value");
        var quantityName = $(this).find(".wcs-quantity").attr("name");
        var quantityValue = $(this).find(".wcs-quantity").attr("value");

        var itemReasonName = "reason_" + itemName.split("_")[1];
        if ($("select[name='" + itemReasonName + "']").length) {
        	var itemReasonValue = $("select[name='" + itemReasonName + "']").val();

            if (itemReasonValue.split("-", 1) == "RET")
                noReturnItems++;

            params[itemName] = itemNameValue;
            params[quantityName] = quantityValue;
            params[itemReasonName] = itemReasonValue;
            params.isReturnCalculate = "true";
            params.rmaId = $('#wcs-rma-id').val();
            params.addId = $('#wcs-add-id').val();
            
            // RB-16752 - Passing proper storeId, catalogId and langId
            params.storeId = $('#storeId').val();
            params.catalogId = $('#catalogId').val();
            params.langId = $('#langId').val();
            
            /*if(eachReasonCode.split("-",1).toString() =='RET')
             params.price = $(this).find(".wcs-return-price").data("price");
             else if(eachReasonCode.split("-",1).toString() =='REP')
             params.price = $(this).find(".wcs-replace-price").data("price");*/	
        }
    });

    params.noReturnItems = noReturnItems;

    if ($("#shippingTypeSelectionEnabled").val() == "true") {
        params.shippingType = $('.wcs-shipping-service-radio:checked').val();
    }

    return params;
};

window.updateKeepCount = function() {
    keep = 0;
    totalItems = 0;
    $(".wcs-return-reason-dd option:selected").each(function() {
        totalItems++;
        if (this.value == "REP-KP")
            keep++;
    });
};

window.updateKeepInOrderCount = function(currentObj) {
    keepInEachOrder = 0;
    totalItemsInEachOrder = 0;
    $(currentObj).parents(".wcs-myOrder-details-content").find(".wcs-return-reason-dd option:selected").each(function() {
        totalItemsInEachOrder++;
        if (this.value == "REP-KP")
            keepInEachOrder++;
    });
};

window.calcAndFormatPrice = function(quantity, unitPrice) {
    var currencyFormat = $(".wcs-create-return").data("currency-format");
    var totalPrice = quantity * unitPrice;
    return currencyFormat.replace(/[#0\.,']+/, function(match) {
        return format(match, totalPrice);
    });
};

window.addressRadioHandler = function() {
    // Radio button change listener
    $(".wcs-address-radios input:radio").on("change", function() {
    	
        if($("#isPickupAddress").val()=='PU'){ 
        if ($('.wcs-address-radios .wcs-orig-add-radio').is(':checked')) {        	
        	$("#own_servcie").attr("checked", true).parent().addClass("wcs-r-on");
            $("#ups_service").removeAttr("checked").parent().removeClass("wcs-r-on"); 
            $("#prepaid_service").removeAttr("checked").parent().removeClass("wcs-r-on"); 
        	$("#own_servcie").attr('disabled', true);
        	$("#ups_service").attr('disabled', true);
        	$("#prepaid_service").attr('disabled', true);    
        	$(".wcs-radio-pickup").addClass("wcs-disabled");
        }
        else{ 
        	
        	$("#own_servcie").attr('disabled', false);
        	$("#ups_service").attr('disabled', false);
        	$("#prepaid_service").attr('disabled', false);    
        	$(".wcs-radio-pickup").removeClass("wcs-disabled");
        }
        }
        // UPS service availability for selected address
        upsServiceAvailability($(this).data("upsservice"));

        // if shipmentServiceTypeSelection is enabled
        var shipmentCost = 0;
        if ($(".wcs-shipping-service-radio").length > 0) {
            shipmentCost = $(".wcs-shipping-service-radio:checked").data("shipment-cost");
        }

        if ((parseInt($("#ajax_response").find("#return_shipment_cost").val()) <= 0 || $("#ajax_response").find("#return_shipment_cost").val() === undefined) && Number(shipmentCost) === 0) {
            if ($('.wcs-address-radios .wcs-orig-add-radio').is(':checked')) {
                showConfirmButton();
            } else if ($('.wcs-address-radios .wcs-new-add-radio').is(':checked')) {
                showNextButton();
            }
        }
    });
};

window.upsServiceAvailability = function(upsservice) {
    if (upsservice === true) {
        $("#ajax_response").find(".wcs-no-ups-service").addClass("wcs-hide");
        $("#ajax_response").find(".wcs-return-shipment-cost").removeClass("wcs-hide");
    } else if (upsservice === false) {
        $("#ajax_response").find(".wcs-no-ups-service").removeClass("wcs-hide");
        $("#ajax_response").find(".wcs-return-shipment-cost").addClass("wcs-hide");
    } else if (upsservice == "newadd") {
        $("#ajax_response").find(".wcs-no-ups-service").addClass("wcs-hide");
        $("#ajax_response").find(".wcs-return-shipment-cost").addClass("wcs-hide");
    }
};

window.onShippingTypeSelection = function() {
    $(".wcs-shipping-service-radio").on("change", function() {
        // Check for selected delivery add
        var deliveryAddSelected = ($(".wcs-address-radios input:radio:checked").hasClass("wcs-new-add-radio") === true) ? "newadd" : "origadd";

        if ((parseInt($("#ajax_response").find("#return_shipment_cost").val()) <= 0 || $("#ajax_response").find("#return_shipment_cost").val() === undefined) && deliveryAddSelected != "newadd") {
            if ($(this).data("shipment-cost") > 0) {
                showNextButton();
            } else {
                showConfirmButton();
            }
        }
    });
};

window.countryPhoneCodeValidation = function(){
	window.currentValue = "";
	$("#tel_code").off("focus").on("focus", function(){
		window.currentValue = $(this).val();
		$(this).val("+");
	});
	$("#tel_code").off("blur").on("blur", function(){
		console.log(window.currentValue);
		if($(this).val() === "+"){
			$(this).val(window.currentValue);
		}
	});
};

window.openChatWindow = function(e) {

    if ($('#chatPrivacy').is(':checked')) {
        $("#agreeConcent").attr("checked", "checked");
    } else {
        $("#agreeConcent").removeAttr("checked");
        $("#chatPrivacy").siblings(".rb-fieldrow-checkbox__checkmark").css("border-color", "red");
    }
    $("#chatPrivacy").change(function() {
        $("#chatPrivacy").siblings(".rb-fieldrow-checkbox__checkmark").removeAttr("style");
    });
    
    Rayban.ChatFormData = Rayban.storage.fetch("chatFormData",{ stringify: true });
   
    if(Rayban.ChatFormData === undefined || Rayban.ChatFormData === null) Rayban.ChatFormData = {};
   
    if(Rayban.ChatFormData !== undefined ) {
          $.each(Rayban.ChatFormData, function(objId, val){
            $("#"+objId).val(val);
          });

          if(Rayban.ChatFormData.agreeConcent === "true" && !$("#agreeConcent").is(":checked")) {
            $("#unified_chat_form .wcs-label-check").click();
          }
    } 
	$(".wcs-new-contact-us-design .infoSection .leftInfoSection").eq(1).find("span").css("width","185%");
	countryPhoneCodeValidation();



	$("#wcs_support_chat_form").off('submit.chat').on('submit.chat', function(e) {
        e.preventDefault();
        var unifiedChatEnabled = $("#UnifiedChatEnable").val();
        if( $('#wcs_support_chat_form').h5Validate('allValid')){
	        var altServiceIP = $('#altServiceIP').val();
	        var DNISForCTC = $('#DNISForCTC').val();
	        var firstName = $('#firstName').val();
	        var language = $('#language').val().toUpperCase();
	        var storeIdentifier = $('#storeIdentifier').val();
	        if (storeIdentifier == 'USA') {
	        	storeIdentifier='US';
	        }
	        var lastName = $('#lastName').val();
	        var email1 = $('#email1').val();
	        var phoneNumber = $('#phoneNumber').val();
	        var topic = $('#wcs_support_topic').val();
		    
			var mainwin;
	        var wdh = 0.25 * $(window).width();
	        var hgt = 0.75 * $(window).height();
	        //Changes for new language parameter in CTC   
	        var data=language+"|"+firstName+"|"+(lastName?lastName:"")+"|"+email1+"|"+phoneNumber+"|"+storeIdentifier+"|"+topic + "&number=" + email1 + "&lang="+ language +"&callonopen=";
	        var url = altServiceIP + '?dnis=' + DNISForCTC + "&data=" +data;
	        if(window.console) console.log(url);
	        show_full_fadeout_1();
	        var $chatDiv = $('#wcs-support-chat-popup');
	        $chatDiv.css({
	            height: hgt,
	            width: wdh
	        }).find('iframe').css({
	            height: hgt,
	            width: wdh
	        }).attr('src', url);
	        display_center_1($chatDiv);
	        $chatDiv.show();
	        $('article.wcs-support-form-feedback').removeClass('wcs-hide');
	        $('article.wcs-support-form-div').addClass('wcs-hide');
        }
    });
    $("#unified_chat_form input").off("keyup").on("keyup", function(){
        storeChatFormData(this);
    });

    $("#unified_chat_form select").off("change").on("change", function(){
        storeChatFormData(this);
    });
    
    $(".wcs-label-check").click(function(){
    	var checkFormId = $(this).closest('form#user_register_form');
    	if (!(checkFormId.attr('id'))) {
	    	if(!$("#agreeConcent").is(":checked")) {
	    		Rayban.ChatFormData.agreeConcent = "true";
	    		Rayban.storage.save("chatFormData",Rayban.ChatFormData,{ stringify: true });
	    	}else{
	    		Rayban.ChatFormData.agreeConcent = "false";
	    		Rayban.storage.save("chatFormData",Rayban.ChatFormData,{ stringify: true });
	    	}
    	}
    });
    

    $(".popup-blocked-message .start-chat").off("click").on("click", function(){
        $(".wcs-support-form-div").removeClass("wcs-hide");
        $(".wcs-unified-form-feedback").addClass("wcs-hide");
        $(".popup-blocked-message").addClass("wcs-hide");

         Rayban.ChatFormData  = Rayban.storage.fetch("chatFormData",{ stringify: true });
         if(Rayban.ChatFormData !== undefined ) {
              $.each(Rayban.ChatFormData, function(objId, val){
                $("#"+objId).val(val);
              });
         } 
         if(Rayban.ChatFormData.agreeConcent === "true" && !$("#agreeConcent").is(":checked")) {
            $("#unified_chat_form .wcs-label-check").click();
         }

         //Rayban.storage.remove("chatFormData");
    });
    window.storeChatFormData = function(obj){
        var ObjId = $(obj).attr("id");
        var objval = $(obj).val();
        Rayban.ChatFormData[ObjId] = objval;
        Rayban.storage.save("chatFormData",Rayban.ChatFormData,{ stringify: true });
    };
	$("#unified_chat_form").off('submit').on('submit', function(e) {
		e.preventDefault();

		var unifiedChatEnabled = $("#UnifiedChatEnable").val();
		if($('#unified_chat_form').h5Validate('allValid')){
			var altServiceIP = $('#altServiceIP').val();
	        var DNISForCTC = $('#DNISForCTC').val();
	        var firstName = $('#userFName').val();
	        var language = $('#locale').val();
	        var storeIdentifier = $('#storeIdentifier').val();
	        if (storeIdentifier == 'USA') {
	        	storeIdentifier='US';
	        }
	        if (storeIdentifier == 'GB') {
	        	storeIdentifier='UK';
	        }
	        var lastName = $('#userLName').val();
	        var email1 = $('#email1').val();
	        var phoneNumber = $('#tel_code').val() + $("#tel_number").val();
	        var topic = $('#unified_chat_topic').val();
	        	
	        	var layoutConfig = {
	                    width: 400,
	                    height: 400,
	                    title: 'Chat'
	                };
	        	
	        	var dataConfig = {
	                    'Name': firstName,
	                    'Surname': lastName,
	                    'Email': email1,
	                    'Phone': phoneNumber,
	                    'InquiryId': topic,
	                    'Country': storeIdentifier,
	                    'Language': language,
	                    'BrandCode': 'RB'
	                };
	        	
	        	var unifiedChatWindow = new ApiManagerLib();
	        	
	        	unifiedChatWindow.startChat(dataConfig, function (message){
                    //callback function
	        		if(message === "OK"){
	        			$(".wcs-unified-form-feedback").removeClass("wcs-hide");
	        			$(".wcs-eight.unified-chat-container .wcs-unified-form-language.chat").addClass("wcs-hide");
                        $(".popup-blocked-message").removeClass("wcs-hide");
	        			var chatConfig = unifiedChatWindow.getConfiguration(dataConfig);
	        			ININ.webchat.create(chatConfig, function(err, webchat) { 
	        		      if (err) { 
	        		    	  throw err; 
	        		      }
	        		      webchat.renderPopup({
	        		    	  width: 400,
	        		    	  height: 400,
	        		    	  title: "Chat" 
	        		      }); 
	        		      
	        		  });
	        		  Rayban.analytics.contactUsSuccess();                        
	        		}else{
	        			$(".wcs-eight.unified-chat-container .wcs-unified-form-language.chat").addClass("wcs-hide");
	        			$(".wcs-support-form-div").addClass("wcs-hide");
	        			$(".wcs-unified-form-feedback").removeClass("wcs-hide");
	        			$(".wcs-unified-form-feedback p").text(message);
	        			Rayban.analytics.contactUsError("wcs CHATFormpage startChat submit - ", message);
	        		}
                    console.log(JSON.stringify(message, null, 1));
                }, layoutConfig);
	        	
	        	$('article.wcs-support-form-feedback').removeClass('wcs-hide');
      		  	$('article.wcs-support-form-div').addClass('wcs-hide');
      		  	$(".wcs-eight.unified-chat-container .wcs-unified-form-language.chat").addClass("wcs-hide");
	        	
		}
	});
};

window.openCallWindow = function(){
	countryPhoneCodeValidation();
    const telCodeEl = $('#tel_code');
	$("#unified_call_form").off('submit').on('submit', function(e) {
		e.preventDefault();
        if (telCodeEl.val() === '') {
            telCodeEl.val($('#telCode').val());
        }
		if($('#unified_call_form').h5Validate('allValid')){
			var altServiceIP = $('#altServiceIP').val();
	        var DNISForCTC = $('#DNISForCTC').val();
	        var firstName = $('#userFName').val();
	        var language = $('#locale').val();
	        var storeIdentifier = $('#storeIdentifier').val();
	        if (storeIdentifier == 'USA') {
	        	storeIdentifier='US';
	        }
	        if (storeIdentifier === 'GB') {
	        	storeIdentifier = 'UK';
	        }
	        var lastName = $('#userLName').val();
	        var email1 = $('#email1').val();
            var phoneNumber = telCodeEl.val() + $("#tel_number").val();
	        var topic = $('#unified_call_topic').val();
	        var dayINeed="";
	        var selectedHour = "";
	        var day = $("#day").val();
	        var timeDropDownVal = $("#hour").val();
	        if(moment().utc() <= moment().utc().day(day)){
	        	dayINeed = moment().utc().day(day);
	        }else{
	        	dayINeed =  moment().utc().add(1, 'weeks').day(day);
	        }
	        
	        var dateIn24hrformat = moment(timeDropDownVal, ["h:mm A"]).format("HH");
	        console.log(dateIn24hrformat);
	        
	        var dateAndHour = moment(dayINeed).set({hour:dateIn24hrformat, minute:0 ,seconds:0 }).utc().format(),
	        	countryText = 'GMT';
	        
	        $.getJSON('https://momentjs.com/data/moment-timezone-meta.json').then(function (data) {
	        	var countryValue = $("#storeIdentifier").val() === 'USA'? 'US' : $("#storeIdentifier").val(),
	        		multipleTimeZones = {
	        			'US': 20,
	        			'AU': 8
	        		};//Object created for Countries with multiple TimeZone and only one time zone to be picked up
				if(data.countries && data.countries[countryValue] && data.countries[countryValue].zones[multipleTimeZones[countryValue] || 0]){
					countryText = data.countries[countryValue].zones[0];
				}else if(!!data.countries[countryValue]){
					console.log('Country code not found in moment!');
				}
				dateAndHour = moment(dateAndHour).tz(countryText).set({hour:dateIn24hrformat, minute:0 ,seconds:0 }).format();
	    	}, function(){
	    		dateAndHour = moment(dateAndHour).tz(countryText).set({hour:dateIn24hrformat, minute:0 ,seconds:0 }).format();
	    	}).then(function(){
	    		
	    		var dataConfig = {
                    'Name': firstName,
                    'Surname': lastName,
                    'Email': email1,
                    'Phone': phoneNumber,
                    'InquiryId': topic,
                    'DateAndHour': dateAndHour,
                    'Country': storeIdentifier,
                    'Language': language,
                    'BrandCode': 'RB'
                };
	        
	        	var unifiedCallBack = new ApiManagerLib();
	        	
	        	unifiedCallBack.callMeBack(dataConfig, function (message){
	                //callback function
	                console.log(JSON.stringify(message, null, 1));
	                if(message !== ""){
	                	if(message.returnCode !== -1){
		                	$(".wcs-nine.unified-chat-container p.wcs-width-474").addClass("wcs-hide");
		                	$(".wcs-nine.unified-chat-container form").addClass("wcs-hide");
		                	$(".wcs-nine.unified-chat-container .wcs-unified-form-language").addClass("wcs-hide");
		                	$(".wcs-support-form-success").removeClass("wcs-hide");
		                	Rayban.analytics.contactUsSuccess();
	                	}else{
	                		$(".wcs-nine.unified-chat-container p.wcs-width-474").addClass("wcs-hide");
		                	$(".wcs-nine.unified-chat-container form").addClass("wcs-hide");
		                	$(".wcs-support-form-error p").text(JSON.parse(message.errorDescription.response.body.error.response.text).message);
		                	$(".wcs-support-form-error").removeClass("wcs-hide");
		                	Rayban.analytics.contactUsError("wcs callbackFormPage callbackChat callback - ", JSON.parse(message.errorDescription.response.body.error.response.text).message);
	                	}
	                }
	            });
	    	});
		}
	});
};

window.showConfirmButton = function() {
    $("#return_order_confirm").show().removeAttr("disabled").removeClass("wcs-btn-disable");
    $("#return_order_next").hide().attr("disabled", true).addClass("wcs-btn-disable");
};

window.showNextButton = function() {
    $("#return_order_next").show().removeAttr("disabled").removeClass("wcs-btn-disable");
    $("#return_order_confirm").hide().attr("disabled", true).addClass("wcs-btn-disable");
};

window.optionchange=function(){
    // Drop down option change listener
    $(document).on('change','.wcs-return-reason-dd',function(){
      updateReturnsForm(this);
    });

};

window.showCustomerCareHours = function () {
    if (typeof moment === "function" && typeof moment() === "object") {
        var mondayToFridayWorkingHours = moment($("#startingHourWeekday").val(), "hh:mm").format("HH") + " am -" + moment($("#endingHourWeekday").val(), "hh:mm").format("HH") + " pm " + "(" + $("#timeZone").val() + ")";
        var saturdayWorkingHours = moment($("#startingHourSaturday").val(), "hh:mm").format("HH") + " am -" + moment($("#endingHourSaturday").val(), "hh:mm").format("HH") + " pm " + "(" + $("#timeZone").val() + ")";
        var sundayWorkingHours = moment($("#startingHourSunday").val(), "hh:mm").format("HH") + " am -" + moment($("#endingHourSunday").val(), "hh:mm").format("HH") + " pm " + "(" + $("#timeZone").val() + ")";

        var closedText = $("#closedText").val();

        $("#needHelpRightSection span.mondayToFridayContent").text(mondayToFridayWorkingHours);
        if ($("#saturdayWorking").val() === "Yes") {
            $("#needHelpRightSection span.saturdayContent").text(saturdayWorkingHours);
        } else {
            $("#needHelpRightSection span.saturdayContent").text(closedText);
        }
        if ($("#sundayWorking").val() === "Yes") {
            $("#needHelpRightSection span.sundayContent").text(sundayWorkingHours);
        } else {
            $("#needHelpRightSection span.sundayContent").text(closedText);
        }
    }
}

function updateReturnsForm(currentObj){

        var reasonCode = $(currentObj).find(":selected").val();
        var reasonPrefix = reasonCode.split("-", 1).toString();
        if($('#country').val() === 'BR'){
            var returnReasonCount = 0,
                dropDownsInAnOrder = $(currentObj).parents('.wcs-shopping-item-content').find('.wcs-return-reason-dd'),
                returnReasonSelectBoxesCount = dropDownsInAnOrder.length,
                orderSiblings = $(currentObj).parents('.wcs-shopping-item-content').siblings('.wcs-shopping-item-content').find('.wcs-return-reason-dd');

            dropDownsInAnOrder.each(function() {
                    if($(currentObj).children('option:first-child').is(':selected')){
                        returnReasonCount = returnReasonCount + 1;
                    }
            });
            if(returnReasonCount === returnReasonSelectBoxesCount){
                orderSiblings.removeClass('noclick wcs-opacity-40');
            }
            if (!$(currentObj).children('option:first-child').is(':selected')) {
                orderSiblings.addClass('noclick wcs-opacity-40');
            }
        }
        $(".wcs-create-return .wcs-myOrder-rows").each(function() {
            var quantity = $(currentObj).find(".wcs-return-price").data("price");
            var unitPrice = $(currentObj).find(".wcs-quantity").val();
            $(currentObj).find(".wcs-return-price").html(calcAndFormatPrice(quantity, unitPrice));
            if($("#insuranceCart").val() == "true"){
            	$(currentObj).find(".wcs-return-price").append('<div class="wcs-rox-ins-line-through"></div>');
            }
        });
        showHideUnitPrice(currentObj, reasonPrefix, reasonCode);
        showHideReturnReasonResponse(currentObj, reasonPrefix, reasonCode);

        // Update the total dd and keep count
        updateKeepCount();

        // Update the total dd and keep count in current order
        updateKeepInOrderCount(currentObj);

        if ($("#loggedin_user").val() == "R" && keepInEachOrder != totalItemsInEachOrder)
            $(currentObj).parents(".wcs-myOrder-details-content").prev(".wcs-myOrder-details").removeClass("wcs-order-history");
        else if ($("#loggedin_user").val() == "R" && keepInEachOrder == totalItemsInEachOrder) {
            $(currentObj).parents(".wcs-myOrder-details-content").prev(".wcs-myOrder-details").addClass("wcs-order-history");
        }

        if (keep == totalItems) {
            // If user decides to keep all products
            $(".wcs-create-return").find("#ajax_response").empty();
            //$(".wcs-createReturn-ctrls").css("border-top","2px solid #ccc");
            $("#orig_add_radio").attr("checked", true).parent().addClass("wcs-r-on");
            $("#new_add_radio").removeAttr("checked").parent().removeClass("wcs-r-on");
            $("#return_order_confirm").show().attr("disabled", true).addClass("wcs-btn-disable");
            $("#return_order_next").hide().attr("disabled", true).addClass("wcs-btn-disable");
            $(".wcs-note-org-shipment").hide();
            $("#wcs_ups_service_msg").removeClass("wcs-hide");
            $("#wcs_own_service_msg").addClass("wcs-hide");
        } else {

            //$(".wcs-createReturn-ctrls").css("border-top",0);
            $(".wcs-note-org-shipment").show();

            createReturnCostAjax(collectParams(), "CreateReturnCalcCmd",true);
        }
    if ($('#store-identifier').val() === 'JP') {
        if (reasonCode !== 'REP-KP') {
            $('#scheduled-return-section').show();
        } else {
            $('#scheduled-return-section').hide();
        }
    }
}

function updateForm(currentObj){
     // Update the total dd and keep count
            updateKeepCount();

            // Update the price shown based on quantity selected
            var quantity = $(currentObj).parents(".wcs-custom-dropdown-container").find(".wcs-dropdown-text").val();
            var unitPrice = $(currentObj).parents(".wcs-myOrder-rows").find(".wcs-return-price").data("price");
            $(currentObj).parents(".wcs-myOrder-rows").find(".wcs-return-price").html(calcAndFormatPrice(quantity, unitPrice));

            if (keep != totalItems) {
                createReturnCostAjax(collectParams(), "CreateReturnCalcCmd");
            }
    };


function setSerialNumber() {
    let serialNumberAttr = 'data-serial-number',
        itemIdAttr = 'data-item-id',
        popupItem = $('#js-check-sn-modal'),
        uncheckBtn = popupItem.find('#js-uncheck-selection'),
        confirmBtn = popupItem.find('#js-confirm-sn'),
        serialNumberContainer = $('.serial-num-container'),
        serialNumbersInput = $('#serialNumber'),
        closeModalBtn = $('#close-sn-modal'),
        isAnyButtonClicked = false;
    function removePartOfValue(removePart) {
        let currenValue = serialNumbersInput.val();
        let newValue = currenValue.split(',').filter(function (el) { return el !== removePart }).join(',');
        serialNumbersInput.val(newValue);
    }
    function disableReturnReasonSelect(element) {
        element.val('REP-KP');
        element.trigger('change');
        element.prop('disabled', true);
    }
    function getReturnReasonSelect(childElement) {
        return childElement.closest('.js-create-return-item').find('.wcs-return-reason-dd');
    }
    function uncheckSelection() {
        const $itemCheckbox = $('#' + uncheckBtn.data('returnItemId'));
        $itemCheckbox.prop('checked', false);
        confirmBtn.attr(itemIdAttr, '');
        confirmBtn.attr(serialNumberAttr, '');
    }

    $('.js-return-item-cb').on('change', function () {
        let currElement = $(this);
        const itemId = currElement.attr(itemIdAttr);
        const returnItemId = currElement.attr('id');
        const serialNumber = currElement.attr(serialNumberAttr);
        if (this.checked) {
            isAnyButtonClicked = false;
            popupItem.show();
            serialNumberContainer.text(serialNumber);
            uncheckBtn.data('returnItemId', returnItemId);
            confirmBtn.data('returnItemId', returnItemId);
            confirmBtn.attr(serialNumberAttr, serialNumber);
            confirmBtn.attr(itemIdAttr, itemId);
        } else {
            const $itemReturnReasonSelect = getReturnReasonSelect(currElement);
            disableReturnReasonSelect($itemReturnReasonSelect);
            removePartOfValue(itemId + '-' + serialNumber);
        }
    });

    closeModalBtn.on('click', function () {
        if (!isAnyButtonClicked) {
            uncheckSelection();
        }
        popupItem.hide();
    });

    uncheckBtn.on('click', function () {
        uncheckSelection();
        isAnyButtonClicked = true;
        closeModalBtn.trigger('click');
    });

    confirmBtn.on('click', function () {
        const itemId = confirmBtn.attr(itemIdAttr);
        const serialNumber = confirmBtn.attr(serialNumberAttr);
        const returnItemId = confirmBtn.data('returnItemId');
        let oldVal = serialNumbersInput.val();
        if (oldVal) {
            serialNumbersInput.val(oldVal + ',' + itemId + '-' + serialNumber);
        } else {
            serialNumbersInput.val(itemId + '-' + serialNumber);
        }
        const $itemReturnReasonSelect = getReturnReasonSelect($('#' + returnItemId));
        $itemReturnReasonSelect.prop('disabled', false);
        isAnyButtonClicked = true;
        closeModalBtn.trigger('click');
    });
}

$(window).on('load', function() {
    setSerialNumber()
});